import { render, staticRenderFns } from "./AssetsGeneralReport.vue?vue&type=template&id=47148c36"
import script from "./AssetsGeneralReport.vue?vue&type=script&lang=js"
export * from "./AssetsGeneralReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports